export const PAGE_TYPES = [
  { page: "Premium-home", value: 1 },
  { page: "Premium-Article-Listing", value: 2 },
  { page: "Premium-Category-Listing", value: 3 },
  { page: "Premium-Webinar-Home", value: 4 },
  { page: "Premium-Article", value: 5 },
  { page: "Premium-Webinar", value: 6 },
  { page: "Premium-FAQs", value: 7 },
  { page: "Article", value: 8 },
  { page: "College-Listing", value: 9 },
  { page: "college", value: 10 },
  { page: "course", value: 11 },
  { page: "Dashboard", value: 12 },
];

export const domainValue = [
  { domain: "engineering", value: 1 },
  { domain: "bschool", value: 2 },
  { domain: "medicine", value: 3 },
  { domain: "law", value: 4 },
  { domain: "design", value: 5 },
  { domain: "media", value: 6 },
  { domain: "finance", value: 9 },
  { domain: "it", value: 10 },
  { domain: "pharmacy", value: 11 },
  { domain: "hospitality", value: 13 },
  { domain: "competition", value: 14 },
  { domain: "school", value: 15 },
  { domain: "studyabroad", value: 16 },
  { domain: "university", value: 17 },
  { domain: "www", value: 18 },
  { domain: "news", value: 20 },
  { domain: "hindinews", value: 24 },
  { domain: "certification", value: 23 },
];

export const educationLevel = [
  { label: "Graduate and Above", value: 14 },
  { label: "Graduation", value: 13 },
  { label: "Class 12th", value: 12 },
  { label: "Class 11th", value: 11 },
  { label: "Class 10th", value: 10 },
  { label: "Class 9th", value: 9 },
  { label: "Class 8th", value: 8 },
  { label: "Class 7th", value: 7 },
  { label: "Class 6th", value: 6 },
];

export const schoolBoard = [
  { label: "CBSE", value: "cbse" },
  { label: "State Board", value: "state board" },
  { label: "ICSE", value: "icse" },
];

export const streams = [
  { label: "PCM", value: "pcm" },
  { label: "PCB", value: "pcb" },
  { label: "PCMB", value: "pcmb" },
  { label: "Arts", value: "arts" },
  { label: "Commerce", value: "commerce" },
  { label: "Undecided", value: "undecided" },
];

export const streamsForEleventh = [
  { label: "PCM", value: "pcm" },
  { label: "PCB", value: "pcb" },
  { label: "PCMB", value: "pcmb" },
  { label: "Arts", value: "arts" },
  { label: "Commerce", value: "commerce" },
];

export const passingYear = [
  { label: "2023", value: 2023 },
  { label: "2024", value: 2024 },
  { label: "2025", value: 2025 },
];

export const targetYearBschool = [
  { label: "CAT 2022 Targeting Admission in 2023", value: 2021 },
  { label: "Sep MAT 2022 Targeting Admission in 2023", value: 2022 },
  { label: "CAT 2023 Targeting Admission in 2024", value: 2025 },
  { label: "Targeting Admission in 2023", value: 2023 },
  { label: "Targeting Admission in 2024", value: 2024 },
];

export const educationInterest = [
  { label: "Engineering and Architecture", value: 1 },
  { label: "Management", value: 2 },
  { label: "Medicine and Allied Sciences", value: 3 },
  { label: "Law", value: 4 },
  { label: "Animation and Design", value: 5 },
  { label: "Media, Mass Communication and Journalism", value: 6 },
  { label: "Arts, Humanities and Social Sciences", value: 7 },
  { label: "Sciences", value: 8 },
  { label: "Commerce", value: 9 },
  { label: "Computer Application and IT", value: 10 },
  { label: "Pharmacy", value: 11 },
  { label: "Education", value: 12 },
  { label: "Hospitality and Tourism", value: 13 },
];

export const educationInterestStudyAbroad = [
  { label: "Engineering & Technology", value: 80 },
  { label: "Arts & Humanities", value: 81 },
  { label: "Life Sciences, Clinical & Medicine", value: 82 },
  { label: "Business & Economics", value: 83 },
  { label: "Law", value: 84 },
  { label: "Natural Sciences", value: 85 },
  { label: "Social Science", value: 86 },
  { label: "Computer Science", value: 87 },
];

export const educationInterestAll = [
  { label: "Engineering and Architecture", value: 1 },
  { label: "Management", value: 2 },
  { label: "Medicine and Allied Sciences", value: 3 },
  { label: "Law", value: 4 },
  { label: "Animation and Design", value: 5 },
  { label: "Media, Mass Communication and Journalism", value: 6 },
  { label: "Arts, Humanities and Social Sciences", value: 7 },
  { label: "Sciences", value: 8 },
  { label: "Commerce", value: 9 },
  { label: "Computer Application and IT", value: 10 },
  { label: "Pharmacy", value: 11 },
  { label: "Education", value: 12 },
  { label: "Hospitality and Tourism", value: 13 },
  { label: "Engineering & Technology", value: 80 },
  { label: "Arts & Humanities", value: 81 },
  { label: "Life Sciences, Clinical & Medicine", value: 82 },
  { label: "Business & Economics", value: 83 },
  { label: "Law", value: 84 },
  { label: "Natural Sciences", value: 85 },
  { label: "Social Science", value: 86 },
  { label: "Computer Science", value: 87 },
];

export const month = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
